import React, { FC } from "react";
import Tooltip from "@mui/material/Tooltip";
import {
  FaArrowLeft,
  FaArrowRight,
  FaCheck,
  FaCheckCircle,
  FaTrashAlt
} from "react-icons/fa";
import { ANSWERSTATUSENUM } from "../../environment";

type ButtonPanelProps = {
  exam: any;
  handlePrevious: () => void;
  isReviewCase: boolean;
  currentIndex: number;
  examQuestionDetails: any;
  markforreview: () => void;
  Answers: {
    ans_id: number | string | null;
    section: string;
  };
  clearresponse: () => void;
  reviewedIndex: number;
  reviewwdArray: number[];
  setanswer: ({
    finalCallback,
    isFinal,
    timesUpCallback
  }: {
    finalCallback?: any;
    timesUpCallback?: any;
    isFinal?: boolean;
  }) => void;
  setShowWarningModal: React.Dispatch<React.SetStateAction<boolean>>;
};
const ButtonPanel: FC<ButtonPanelProps> = ({
  handlePrevious,
  reviewwdArray,
  exam,
  setanswer,
  reviewedIndex,
  setShowWarningModal,
  isReviewCase,
  currentIndex,
  examQuestionDetails,
  Answers,
  markforreview,
  clearresponse
}) => {
  return (
    <div className="  flex flex-col lg:flex-row md:justify-between md:items-center md:space-y-0 space-y-3 md:space-x-2 mt-5 py-2 mb-4 md:mb-0 md:px-4  px-1">
      <div className="flex justify-between items-center">
        <Tooltip title="Previous" arrow>
          <button
            className={`flex md:items-center px-4 py-2 bg-white text-gray-600 border border-gray-500 hover:bg-gray-100 rounded-md ${
              (isReviewCase &&
                reviewedIndex > 0 &&
                reviewwdArray.indexOf(currentIndex) >= 0) ||
              currentIndex > 0
                ? "visible"
                : "invisible"
            }`}
            id="save"
            onClick={handlePrevious}
          >
            <FaArrowLeft className="mr-2" />
          </button>
        </Tooltip>
        <Tooltip title="Next" arrow>
          <button
            className={`flex items-center px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 ${
              (isReviewCase && reviewwdArray.indexOf(currentIndex) >= 0) ||
              (examQuestionDetails &&
                examQuestionDetails?.questions &&
                Array.isArray(examQuestionDetails?.questions) &&
                examQuestionDetails.questions.length > currentIndex)
                ? "visible"
                : "invisible"
            }`}
            id="save"
            type="button"
            onClick={() => setanswer({})}
          >
            {(isReviewCase &&
              reviewwdArray.length > 0 &&
              reviewwdArray[reviewwdArray.length - 1] === currentIndex) ||
            (examQuestionDetails &&
              examQuestionDetails?.questions &&
              Array.isArray(examQuestionDetails?.questions) &&
              examQuestionDetails.questions.length &&
              examQuestionDetails.questions.length - 1 === currentIndex) ? (
              "Save"
            ) : (
              <>
                <FaArrowRight className="ml-2" />
              </>
            )}
          </button>
        </Tooltip>
      </div>
      {/* Left Section (Clear, Mark for Review & Next, Submit) */}
      <div className="flex justify-between mt-6  items-center ">
        {/* Mark for Review & Next Button */}
        {/* <button
            className={`flex items-center px-4 py-2 text-white rounded-md bg-cyan-500 hover:bg-cyan-600 ${
              (exam && isReviewCase && currentIndex >= 0) ||
              (exam &&
                examQuestionDetails?.questions &&
                Array.isArray(examQuestionDetails?.questions) &&
                currentIndex >= 0)
                ? "visible"
                : "invisible"
            }`}
            id="review"
            onClick={markforreview}
          >
            <FaCheckCircle className="mr-2 hidden md:block" />
            <span className="hidden md:block">Mark for Review & Next</span>
            <span className="block md:hidden text-[12px] font-semibold">Review & Next</span>
            <FaArrowRight className="ml-2" />
          </button> */}

        {/* Clear Button */}
        <button
          className={`flex items-center px-4 py-2 text-white rounded-md bg-gray-400 hover:bg-gray-500 ${
            !!Answers && !!Answers?.ans_id ? "visible" : "invisible"
          }`}
          id="clear"
          onClick={clearresponse}
        >
          <FaTrashAlt className="mr-2" />
          <span className="text-xs font-semibold">Clear</span>
        </button>
        <button
          className={`flex items-center px-4 py-2 rounded-md ${
            (exam &&
              examQuestionDetails?.questions &&
              Array.isArray(examQuestionDetails?.questions) &&
              examQuestionDetails.questions.length - 1 === currentIndex) ||
            (exam &&
              examQuestionDetails?.questions &&
              Array.isArray(examQuestionDetails?.questions) &&
              examQuestionDetails.questions[
                examQuestionDetails.questions.length - 1
              ]?.status &&
              [
                ANSWERSTATUSENUM.ATTEMPT,
                ANSWERSTATUSENUM.REVIEW,
                ANSWERSTATUSENUM.SKIP,
              ].includes(
                examQuestionDetails.questions[
                  examQuestionDetails.questions.length - 1
                ]?.status
              ))
              ? "bg-[#08bd80] text-white hover:bg-green-600"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
          id="submit"
          onClick={() =>
            setanswer({
              finalCallback: () => setShowWarningModal(true),
              isFinal: true,
            })
          }
          disabled={
            !(
              (exam &&
                examQuestionDetails?.questions &&
                Array.isArray(examQuestionDetails?.questions) &&
                examQuestionDetails.questions.length - 1 === currentIndex) ||
              (exam &&
                examQuestionDetails?.questions &&
                Array.isArray(examQuestionDetails?.questions) &&
                examQuestionDetails.questions[
                  examQuestionDetails.questions.length - 1
                ]?.status &&
                [
                  ANSWERSTATUSENUM.ATTEMPT,
                  ANSWERSTATUSENUM.REVIEW,
                  ANSWERSTATUSENUM.SKIP,
                ].includes(
                  examQuestionDetails.questions[
                    examQuestionDetails.questions.length - 1
                  ]?.status
                ))
            )
          }
        >
          <FaCheck className="mr-2" />
          <span className="text-xs font-semibold">Submit</span>
        </button>
      </div>
    </div>
  );
};

export default ButtonPanel;
